import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Link from '@tiptap/extension-link';
import Highlight from '@tiptap/extension-highlight';
import TextAlign from '@tiptap/extension-text-align';
import Placeholder from '@tiptap/extension-placeholder';
import { Table, TableRow, TableHeader, TableCell } from '@tiptap/extension-table';
import TaskList from '@tiptap/extension-task-list';
import TaskItem from '@tiptap/extension-task-item';
import Image from '@tiptap/extension-image';
import CharacterCount from '@tiptap/extension-character-count';

export const emptyTiptapDocument = {
  type: 'doc',
  content: [],
};

export const wikiEditorExtensions = ({ placeholder = 'Rediger la page Wiki...' } = {}) => [
  StarterKit.configure({
    heading: { levels: [1, 2, 3] },
    link: false,
    underline: false,
  }),
  Underline,
  Link.configure({
    openOnClick: false,
    autolink: true,
    linkOnPaste: true,
    HTMLAttributes: {
      rel: 'noreferrer',
    },
  }),
  Highlight,
  TextAlign.configure({
    types: ['heading', 'paragraph'],
  }),
  Placeholder.configure({ placeholder }),
  Table.configure({ resizable: true }),
  TableRow,
  TableHeader,
  TableCell,
  TaskList,
  TaskItem.configure({ nested: true }),
  Image.configure({
    inline: false,
    allowBase64: false,
  }),
  CharacterCount.configure({ limit: 120000 }),
];
